import * as React from 'react';
import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Http, LinkedIn } from '@mui/icons-material';
import { useGlobal } from '../../utils/GlobalContext';
import { useEffect, useState } from 'react';
import { UserProfile } from '../../data/userProfile';
import { useNavigate } from 'react-router-dom';
import { UserPresentation } from '../../data/userProfile';
export function SpeakerComponent(){
    const { state } = useGlobal();
    const navigate = useNavigate();
    if (state.UserProfile.IsExistingUser === false) {
      navigate("/account");
  }
    const style = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [speakers, setSpeakers] = useState<UserProfile[]>();
    useEffect(()=>{
        if(state.SelectedEvent!==undefined && state.Profiles!==undefined && 
          state.SelectedEvent.Sessions.length!=0 && 
          speakers==undefined && state.Profiles.length!=0){
            let filteredspeakers: UserProfile[]=[];
            for(let p=0; p< state.Profiles.length; p++){
              for (let i = 0; i < state.SelectedEvent.Sessions.length; i++) {                
                if(state.Profiles[p].PresentationSessions.find((element) => 
                element.EventId === state.SelectedEvent.Sessions[i].EventId && element.SessionId === state.SelectedEvent.Sessions[i].Id
                )!==undefined)
                  {
                      filteredspeakers.push(state.Profiles[p]);
                      break;
                  }
              }
            }
            setSpeakers(filteredspeakers);
        }
    });

return (
    <>
        <h2 className="blueText">{state.SelectedEvent?.Name}  Speakers</h2>
        <br/>
        <br/>
        <Grid container spacing={2}>
        {
          
          speakers?.map((profile) => (
            <>
                <Grid item xs={6} md={2} onClick={handleOpen}>
                    <center>
                        <img className='StaffImage' alt='{profile?.FirstName} {profile?.LastName}' src={(profile?.PictureLink)??"https://creazilla-store.fra1.digitaloceanspaces.com/icons/3220761/user-circle-icon-md.png"}/>
                        <div>{profile?.FirstName} {profile?.LastName}</div>
                        <LinkedIn /> &nbsp; &nbsp; <Http />
                    </center>
                </Grid>
            </>
          ))
        }
        </Grid>
        
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Text in a modal
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
            </Typography>
          </Box>
        </Modal>
    </>
);
};
